import { render, staticRenderFns } from "./quest-text-area.vue?vue&type=template&id=7242befd"
import script from "./quest-text-area.vue?vue&type=script&lang=js"
export * from "./quest-text-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports